// src/pages/auth/VerifyEmail.js
import React, { useEffect, useState } from 'react';
import { Box, Typography, Button, Alert, CircularProgress } from '@mui/material';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Api } from '../../utils/Api';
import { useLanguage } from '../../contexts/LanguageContext'; // ✅ Import language context

function VerifyEmail() {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('loading'); // 'loading', 'success', 'error'
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  const { translations } = useLanguage(); // ✅ Grab translations

  useEffect(() => {
    const verifyToken = async () => {
      const token = searchParams.get('token');
      if (!token) {
        setStatus('error');
        setMessage(translations.auth_pages.invalid_token);
        return;
      }

      try {
        const response = await Api.get(`/users/validate?token=${token}`);
        if (response.data.AccessToken) {
          setStatus('success');
          setMessage(translations.auth_pages.email_verified_success);
        } else {
          setStatus('error');
          setMessage(response.data.message || translations.auth_pages.invalid_token);
        }
      } catch (error) {
        setStatus('error');
        setMessage(translations.auth_pages.error_during_verification);
      }
    };

    verifyToken();
  }, [searchParams, translations.auth_pages]);

  return (
    <Box sx={{ maxWidth: 400, margin: 'auto', mt: 10, p: 3, textAlign: 'center' }}>
      {status === 'loading' && (
        <>
          <Typography variant="h5" component="h1" gutterBottom>
            {translations.auth_pages.verify_email_title}
          </Typography>
          <CircularProgress />
        </>
      )}
      {status === 'success' && (
        <>
          <Alert severity="success" sx={{ mb: 2 }}>
            {message}
          </Alert>
          <Button
            variant="contained"
            sx={{ mt: 2 }}
            onClick={() => navigate('/signin')}
          >
            {translations.auth_pages.go_to_sign_in}
          </Button>
        </>
      )}
      {status === 'error' && (
        <>
          <Alert severity="error" sx={{ mb: 2 }}>
            {message}
          </Alert>
          <Button
            variant="contained"
            sx={{ mt: 2 }}
            onClick={() => navigate('/signup')}
          >
            {translations.auth_pages.back_to_sign_up}
          </Button>
        </>
      )}
    </Box>
  );
}

export default VerifyEmail;
